import React from 'react';
import styles from '../SideDrawer.module.scss';

interface SideDrawerHeaderProps {
    children?: React.ReactNode;
    width?: string;
    rightSlot?: React.ReactNode;
}
function SideDrawerHeader({ children, width, rightSlot }: SideDrawerHeaderProps) {
    return (
        <div className={styles.DrawerHeader}>
            <div style={width ? { width: width } : {}}>{children}</div>
            {rightSlot}
        </div>
    );
}

export default SideDrawerHeader;
